import React from "react";
import { Text } from "@theme-ui/components";

const Heading = ({ content, level = "2" }) => {
  const sizes = {
    2: [4, 5, 6],
    3: [3, 4, 5],
  };
  return (
    <Text
      as={`h${level}`}
      variant="title"
      sx={{
        breakBefore: "avoid",
        pageBreakInside: "avoid",
        fontSize: sizes[level],
        mt: [3, 4, 5],
        mb: [4, 4, 4],
        "&:first-of-type": {
          mt: 0,
        },
      }}
      dangerouslySetInnerHTML={{ __html: content.replace(/(<([^>]+)>)/gi, "") }}
    />
  );
};

export default Heading;
